import { faFilePdf } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Anchor, Tooltip } from '@mantine/core';
import { useTranslation } from 'react-i18next';

type PdfDownloadPropsType = {
  url: string;
};

export const PdfDownload: React.FC<PdfDownloadPropsType> = ({ url }) => {
  const { t } = useTranslation('common');

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.stopPropagation();
  };

  const label = t('ACTIONS.PDF_DOWNLOAD');

  return (
    <Tooltip label={label}>
      <Anchor
        href={url}
        target="_blank"
        onClick={handleClick}
        aria-label={label}
      >
        <FontAwesomeIcon icon={faFilePdf} />
      </Anchor>
    </Tooltip>
  );
};
